var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.placeholderStyle),attrs:{"src":_vm.currentSrc,"alt":_vm.alt,"loading":_vm.loadingAttr,"fetchpriority":_vm.priorityAttr,"decoding":"async","referrerpolicy":"no-referrer"},on:{"error":_vm.handleError,"load":function($event){return _vm.$emit('load', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }